<div class="qb-wrapper">
  <bdr-query-builder-group [query]="query" [schemaItems]="schemaItems" [operators]="operators" [depth]="0"
    [isVisibleButtonTrash]="isVisibleButtonTrash" [gridSelector]="true" [origin]="origin"
    (validationError)="handleValidationError($event)" (isVisibleButtonTrashRequest)="setVisibleButtonTrash($event)"
    (openMainListRequest)="openMainList()" (expandItemMainRequest)="expandItemMain($event)"
    (dragStartMainRequest)="dragStart($event)" (dropMainRequest)="drop($event)">
  </bdr-query-builder-group>
</div>